import React, { Component } from 'react';
import PropTypes from 'prop-types';

import GlobalModule from '../../../containers/global/GlobalModule';
import suitcss from '../../../helpers/suitcss';
import { capitalize } from '../../../helpers/str';
import Tabs from '../../basics/tab/Tabs';

class ContentTabs extends Component {
  static getDerivedStateFromProps(props) {
    const { tabs, location } = props;
    if (tabs.length && location.hash) {
      const locationHash = location.hash;
      const hash = locationHash && locationHash.substring(1);
      const index = tabs.findIndex((tab) => tab.hash === hash);
      if (index >= 0) {
        return {
          activeTab: index,
        };
      }
    }
    return {};
  }

  constructor(props) {
    super(props);

    this.state = {
      activeTab: 0,
    };

    this.onClickTabItem = this.onClickTabItem.bind(this);
  }

  onClickTabItem = (tab) => {
    const { location, tabs, onClickTabItem } = this.props;
    let tabIndex = tab;
    if (typeof tabIndex !== 'number') {
      tabIndex = tabs.findIndex(
        tabItem => tabItem.label === tab.label && tabItem.hash === tab.hash,
      );
      if (tabIndex === -1) {
        return;
      }
    }
    if (location.pathname && tabs[tabIndex].hash) {
      onClickTabItem(tabs[tabIndex].hash);
    }
    this.setState({ activeTab: tabIndex });
  };

  onSwitchChange = () => {
    const { activeTab } = this.state;
    // toggle active tab between idx 0 & 1
    const newActiveTab = activeTab === 0 ? 1 : 0;
    this.onClickTabItem(newActiveTab);
  };

  renderTabsList() {
    const {
      tabs,
      theme,
      switchLabel,
      colorScheme,
      align,
    } = this.props;
    const { activeTab } = this.state;

    return (
      <Tabs
        tabs={tabs}
        theme={theme}
        clickHandler={theme === 'switch' && tabs.length === 2 ? this.onSwitchChange : this.onClickTabItem}
        modifiers={[
          align && `align${capitalize(align)}`,
        ]}
        switchLabel={theme === 'switch' && tabs.length === 2 ? switchLabel : ''}
        colorScheme={colorScheme}
        activeTab={activeTab}
      />
    );
  }

  renderTabContent() {
    const { activeTab } = this.state;
    const { tabs, location } = this.props;
    if (!tabs.length) {
      return null;
    }

    const { modules } = tabs[activeTab];
    return (modules.map(module => (
      <div
        className={suitcss({
          descendantName: 'content',
        }, this)}
        key={module.eid}
      >
        <GlobalModule
          module={module}
          location={location}
          primaryModule={false}
        />
      </div>
    )));
  }

  render() {
    const { tabs } = this.props;

    if (!tabs.length) return null;

    return (
      <div className={suitcss({
      }, this)}
      >
        {this.renderTabsList()}
        {tabs.length && this.renderTabContent()}
      </div>
    );
  }
}

ContentTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.object),
  location: PropTypes.object,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  colorScheme: PropTypes.oneOf(['dark', 'medium', 'light', 'secondary']),
  onClickTabItem: PropTypes.func.isRequired,
  theme: PropTypes.string,
  switchLabel: PropTypes.string,
};

export default ContentTabs;
